import { render, staticRenderFns } from "./OfficeInfoEditor.vue?vue&type=template&id=85bcb89c&scoped=true"
import script from "./OfficeInfoEditor.vue?vue&type=script&lang=js"
export * from "./OfficeInfoEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85bcb89c",
  null
  
)

export default component.exports